'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = require('../constants');

var _constants2 = _interopRequireDefault(_constants);

var Col = (function (_React$Component) {
    _inherits(Col, _React$Component);

    function Col(props) {
        _classCallCheck(this, Col);

        _get(Object.getPrototypeOf(Col.prototype), 'constructor', this).call(this, props);
        this.state = {
            windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0
        };
    }

    _createClass(Col, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (typeof window !== 'undefined') window.addEventListener('resize', this.handleResize.bind(this));
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (typeof window !== 'undefined') window.removeEventListener('resize', this.handleResize.bind(this));
        }
    }, {
        key: 'handleResize',
        value: function handleResize() {
            this.setState({
                windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props;
            var basis = _props.basis;
            var gutter = _props.gutter;
            var xs = _props.xs;
            var sm = _props.sm;
            var md = _props.md;
            var lg = _props.lg;
            var windowWidth = this.state.windowWidth;

            var columnStyle = {
                minHeight: 1,
                paddingLeft: gutter / 2,
                paddingRight: gutter / 2
            };

            // if no width control is provided fill available space
            if (!basis && !xs && !sm && !md && !lg) {
                columnStyle.flex = '1 1 auto';
                columnStyle.msFlex = '1 1 auto';
                columnStyle.WebkitFlex = '1 1 auto';
            }

            // set widths / flex-basis
            if (basis) {
                columnStyle.flex = '1 0 ' + basis;
                columnStyle.msFlex = '1 0 ' + basis;
                columnStyle.WebkitFlex = '1 0 ' + basis;
            } else if (windowWidth < _constants2['default'].breakpoint.xs) {
                columnStyle.width = xs;
            } else if (windowWidth < _constants2['default'].breakpoint.sm) {
                columnStyle.width = sm || xs;
            } else if (windowWidth < _constants2['default'].breakpoint.md) {
                columnStyle.width = md || sm || xs;
            } else {
                columnStyle.width = lg || md || sm || xs;
            }

            if (!columnStyle.width) {
                columnStyle.width = '100%';
            }

            if (columnStyle.width in _constants2['default'].fractions) {
                columnStyle.width = _constants2['default'].fractions[columnStyle.width];
            }

            var className = (0, _classnames2['default'])('Col', this.props.className);
            var props = (0, _blacklist2['default'])(this.props, 'basis', 'gutter', 'style', 'xs', 'sm', 'md', 'lg', 'className');
            return _react2['default'].createElement('div', _extends({
                className: className,
                style: _extends(columnStyle, this.props.style)
            }, props));
        }
    }]);

    return Col;
})(_react2['default'].Component);

Col.propTypes = {
    basis: _propTypes2['default'].oneOfType([_propTypes2['default'].number, // allow pixels
    _propTypes2['default'].string]),
    // allow percentage
    children: _propTypes2['default'].node,
    gutter: _propTypes2['default'].number,
    lg: _propTypes2['default'].string, // width as a percentage or fraction
    md: _propTypes2['default'].string, // width as a percentage or fraction
    sm: _propTypes2['default'].string, // width as a percentage or fraction
    style: _propTypes2['default'].object,
    xs: _propTypes2['default'].string // width as a percentage or fraction
};

Col.defaultProps = {
    gutter: _constants2['default'].width.gutter
};

module.exports = Col;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/Col.js
// module id = 959
// module chunks = 0 1